import React from 'react'

const Social = () => {
  return (
    <div className="home__social">
        <a href='https://www.linkedin.com/in/mohamed-minhal-ali/' className='home__social-icon' target="_blank">
        <i class="uil uil-linkedin"></i>
        </a>

        <a href='https://github.com/minhal15' className='home__social-icon' target="_blank">
        <i class="uil uil-github"></i>
        </a>

    </div>
  )
}

export default Social